/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {Route} from '@angular/router';
import {ErrorComponent} from './error/error.component';
import {TranslateModule} from "@ngx-translate/core";
import {ButtonModule} from "primeng/button";

export const errorRoutes: Route[] = [];

@NgModule({
  imports: [CommonModule, TranslateModule, ButtonModule],
  declarations: [ErrorComponent],
  exports: [ErrorComponent]
})
export class ErrorModule {
}
